"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var TeamConfigurationEntity = /** @class */ (function (_super) {
    __extends(TeamConfigurationEntity, _super);
    function TeamConfigurationEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: 'team_configuration',
            routes: [Entity_1.BaseRoutes.Get, Entity_1.BaseRoutes.Update, Entity_1.BaseRoutes.GetAll]
        }) || this;
    }
    return TeamConfigurationEntity;
}(StoreEntity_1.default));
exports.default = TeamConfigurationEntity;
//# sourceMappingURL=TeamConfigurationEntity.js.map